import { useState, useCallback } from "react";

import { PersonDetailsWithNullPerson } from "../../../../models/Request/RegistrationFormDataChange";
import { useLazyGetPersonDetailsByOibQuery } from "../../../../queries";

export const usePersonOib = () => {
  const [trigger, { isLoading, error }] = useLazyGetPersonDetailsByOibQuery();
  const [fetchedData, setFetchedData] =
    useState<PersonDetailsWithNullPerson | null>(null);
  const [canApply, setCanApply] = useState(false);

  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const fetchPersonDetailsByOib = useCallback(
    async (oib: string) => {
      setCanApply(false);
      setSuccessMessage(null);
      const result = await trigger(oib).unwrap();
      if (!result) return;

      setFetchedData(result);
      setCanApply(true);
      setSuccessMessage("common.oibServiceResultStatus.successRefresh");
    },
    [trigger]
  );

  const applyFetchedData = useCallback(() => {
    setCanApply(false);
    setSuccessMessage("common.oibServiceResultStatus.successApply");

    return fetchedData;
  }, [fetchedData]);

  const clearSuccessMessage = useCallback(() => setSuccessMessage(null), []);

  return {
    data: fetchedData,
    isLoading,
    error,
    fetchPersonDetailsByOib,
    canApply,
    applyFetchedData,
    successMessage,
    clearSuccessMessage,
  };
};
